export default __webpack_public_path__ + "static/media/featuredRace.49c6dc12.png";